<template>
    <div>
        <breadCrumb 
            :icon="'fa-ticket-alt'"
            :category="$t(`sideNav.navSalonReport`)"
            :subCategory="$t(`subMenu.salon_report_voucher`)"
            :subSubCategory="''">
        </breadCrumb>
        <div v-show="selectedTab == 'summary' && filterObj.summaryType == 'date'" class="row mt-3">
            <div class="col-sm-6 col-xl-3" v-for="box in voucherReportSummaryBox" :key="box.id">
                <div class="p-3 rounded overflow-hidden position-relative text-white mb-g" :class="box.background">
                    <div class="">
                        <h3 class="fs-xxl d-block l-h-n m-0 fw-500">
                            {{box.value}}
                            <small class="m-0 l-h-n fw-400 text-capitalize">{{box.text}}</small>
                        </h3>
                    </div>
                    <i class="fal position-absolute pos-right pos-bottom opacity-15 mb-n1 mr-n1" :class="box.icon" style="font-size:5rem"></i>
                </div>
            </div>
        </div>
        <div v-show="selectedTab == 'summary' && filterObj.summaryType == 'customer'" class="row mt-3">
            <div class="col-sm-6 col-xl-3" v-for="box in voucherReportSummaryCustomerBox" :key="box.id">
                <div class="p-3 rounded overflow-hidden position-relative text-white mb-g" :class="box.background">
                    <div class="">
                        <h3 class="fs-xxl d-block l-h-n m-0 fw-500">
                            {{box.value}}
                            <small class="m-0 l-h-n fw-400 text-capitalize">{{box.text}}</small>
                        </h3>
                    </div>
                    <i class="fal position-absolute pos-right pos-bottom opacity-15 mb-n1 mr-n1" :class="box.icon" style="font-size:5rem"></i>
                </div>
            </div>
        </div>
        <ul class="nav nav-tabs nav-tabs-clean px-3 px-sm-5 mt-3" role="tablist">
            <li class="nav-item" v-for="t in $i18n.messages[$i18n.locale].tab.reportCreditTabs" :key="t.id">
                <a class="nav-link bg-transparent fs-lg fw-400" :class="{'active': selectedTab == t.id}" @click="selectedTab = t.id">{{t.text}}</a>
            </li>
        </ul>
        <div class="px-3 px-sm-5 py-4">
            <div class="panel mb-0">
                <div class="panel-hdr border-bottom-0 pt-3 d-block">
                    <voucherFilter ref="voucherFilter" :tab="selectedTab" @setVoucherBalance="setVoucherBalance" @filterCreditSummary="filterCreditSummary" @filterCreditList="filterCreditList"></voucherFilter>
                </div>
                <div class="panel-container show">
                    <div class="panel-content">
                        <div class="tab-content mt-1">
                            <voucherSummary ref="voucherSummary" class="tab-pane" :class="{'active': selectedTab == 'summary'}" @setCustomerSummary="setCustomerSummary" @setSummary="setSummary" @setBalanceSummary="setBalanceSummary" @setExportData="setExportData"></voucherSummary>               
                            <voucherList ref="voucherList" class="tab-pane" :class="{'active': selectedTab == 'list'}" @setExportData="setExportData"></voucherList>               
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import BreadCrumb from './../../Bread_Crumb'
import VoucherFilter from './Voucher_Filter'
import VoucherList from './Voucher_List'
import VoucherSummary from './Voucher_Summary'
import box from './../../../../assets/js/dashboard/salonReport/salonReport'
import {formatPrice} from './../../../../assets/js/dashboard/utilities'
import {setSummaryBoxLabel} from './../../../../assets/js/dashboard/dashboard'
export default {
    name: "reportVoucher",
    components:{
        VoucherFilter, VoucherList, VoucherSummary, BreadCrumb
    },
    data(){
        return {
            selectedTab: "summary",
            voucherReportSummaryBox: [],
            voucherReportSummaryCustomerBox: [],
            filterObj: {}, 
            summaryTab: "customer",
            balance: 0,
        }
    },
    watch:{
        selectedTab(value){
            this.$refs.voucherFilter.updateSummaryType(value);
        },
        "$i18n.locale"(val){
            this.setSummaryBoxLabel()
        }
    },
    methods:{
        async filterCreditSummary(filterObj){
            this.filterObj = filterObj
            await this.$refs.voucherSummary.handleVoucherSummary(this.filterObj);
        },
        filterCreditList(filterObj){
            this.filterObj = filterObj
            this.$refs.voucherList.getVoucherList(this.filterObj);
        },
        setSummary(data){
            for(var i=0; i<this.voucherReportSummaryBox.length; i++){
                switch(this.voucherReportSummaryBox[i].id){
                    case"sign_up":
                        this.voucherReportSummaryBox[i].value = data.summary.signup;
                        break
                    case"redeem":
                        this.voucherReportSummaryBox[i].value = data.summary.redeem;
                        break
                    case"expired":
                        this.voucherReportSummaryBox[i].value = data.summary.expired;
                        break
                    case"balance":
                        this.voucherReportSummaryBox[i].value = data.summary.balance;
                        break
                }
            }
        },
        setCustomerSummary(data){
            for(var i=0; i<this.voucherReportSummaryCustomerBox.length; i++){
                switch(this.voucherReportSummaryCustomerBox[i].id){
                    case"total":
                        this.voucherReportSummaryCustomerBox[i].value = data.total;
                        break
                    case"amount":
                        this.voucherReportSummaryCustomerBox[i].value = parseFloat(data.amount).toFixed(2);
                        break
                }
            }
        },
        setVoucherBalance(data){
            this.filterObj = data;
            this.$refs.voucherSummary.handleVoucherSummary(data);
        }, 
        setBalanceSummary(total){
            this.balance = formatPrice(total)
        },
        setExportData(data){
            this.$refs.voucherFilter.setExportData(data);
        },
        setSummaryBoxLabel(){
            var _box = box.voucherReportSummaryBox
            this.voucherReportSummaryBox = setSummaryBoxLabel(this, 'voucher', _box.slice())

            var _cus_box = box.voucherReportSummaryCustomerBox
            this.voucherReportSummaryCustomerBox = setSummaryBoxLabel(this, 'voucher_customer', _cus_box.slice())
        },
    },
    mounted(){
        let $vm = this
        $vm.setSummaryBoxLabel()
    }
}
</script>
<style scoped>
.nav-link{
    cursor: pointer;
}
</style>